import { SyntheticEvent, useCallback, useLayoutEffect } from "react";
import { PackEditorCallbacks } from "../core/EditorTypes";
import { fileProcessor, OnFileEventFn, OnFileFn } from "../FileProcessor";

type DropZoneProps = {
  onFile: OnFileFn;
  onFileEvent: OnFileEventFn;
  attach?: boolean;
  other?: {
    onChooseDeck: (decks: string[]) => Promise<string>;
    onChooseColumns: (columns: string[]) => Promise<number[]>;
  };
};

function init(onFile: OnFileFn, onFileEvent: OnFileEventFn, other?: {
  onChooseDeck: (decks: string[]) => Promise<string>;
  onChooseColumns: (columns: string[]) => Promise<number[]>;
}) {
  const dropZone = document.querySelector(".dropzone-container")!;
  const fileSelector = document.querySelector("input[type=file")!;

  const idleText = document.querySelector(".dropzone .a")!;
  const hoverText = document.querySelector(".dropzone .b")!;

  dropZone.addEventListener("dragover", (event: Event) => {
    event.stopPropagation();
    event.preventDefault();
    // Style the drag-and-drop as a "copy file" operation.
    // @ts-ignore
    event.dataTransfer.dropEffect = "copy";
    dropZone.classList.add("hover");
    hoverText.classList.remove("hidden");
    idleText.classList.add("hidden");
  });

  dropZone.addEventListener("dragleave", (event) => {
    dropZone.classList.remove("hover");
    hoverText.classList.add("hidden");
    idleText.classList.remove("hidden");
  });

  const onFileWrapper = (...params: any[]) => {
    dropZone.classList.remove("hover");
    hoverText.classList.add("hidden");
    idleText.classList.remove("hidden");
    // console.log('wrapper', params);
    // @ts-ignore
    onFile(...params);
  };

  const processFileSelectEvent = fileProcessor(
    onFileWrapper,
    onFileEvent,
    other,
  );

  dropZone.addEventListener("drop", processFileSelectEvent);
  fileSelector.addEventListener("change", processFileSelectEvent);
}

export default function DropZone(props: DropZoneProps) {
  useLayoutEffect(() => {
    init(props.onFile, props.onFileEvent, props.other);
  }, []);

  return (
    <div
      className={`dropzone-container spacing ${
        props.attach ? "dropzone-mini" : ""
      }`}
    >
      <div className="dropzone" id="file">
        <p className="a">
          🤲 {props.attach ? "attach files" : "drop file here"}
          <span className="sub">
            {props.attach
              ? "(images, sounds, videos)"
              : "(existing pack: .json, .zip, .csv, .apkg)"}
          </span>
        </p>
        <p className="b hidden">✨ let go</p>
        <input type="file" id="file-selector" />
      </div>
    </div>
  );
}

export const FileSelector = (props: DropZoneProps) => {
  const { onFile, onFileEvent, other } = props;
  const onChangeCallback = useCallback(() => {
    fileProcessor(
      onFile,
      onFileEvent,
      other,
    );
  }, [onFile, onFileEvent, other]);
  return <input type="file" id="file-selector" onChange={onChangeCallback} />;
};
//
